/**
 * Implement Gatsby's Browser APIs in this file. Test
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
require("./src/dist/css/bootstrap.min.css")
require("./src/dist/css/font-awesome.min.css")
require("./src/dist/css/material-design-iconic-font.min.css")
require("./src/dist/css/global-custom-style.scss")
require("./src/dist/css/plugins.css")
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    require("intersection-observer")
    console.log(`# IntersectionObserver is polyfilled!`)
  }
}

export const onRouteUpdate = () => {
  // Initialize submenu delays after each route change
  initSubmenuDelays()
}

// Submenu delay functionality
function initSubmenuDelays() {
  // Only apply on desktop (992px and up)
  const isDesktop = window.innerWidth >= 992
  
  if (!isDesktop) {
    return // Don't apply delays on mobile
  }
  
  // Find all submenu dropdowns
  const submenuDropdowns = document.querySelectorAll('.submenu-dropdown')
  
  submenuDropdowns.forEach((dropdown, index) => {
    const timeoutId = `submenu-${index}`
    
    // Remove existing event listeners to prevent duplicates
    dropdown.removeEventListener('mouseenter', dropdown._mouseenterHandler)
    dropdown.removeEventListener('mouseleave', dropdown._mouseleaveHandler)
    
    // Create handlers
    const mouseenterHandler = () => {
      // Clear any existing timeout
      if (dropdown._timeout) {
        clearTimeout(dropdown._timeout)
      }
      
      // Set new timeout
      dropdown._timeout = setTimeout(() => {
        dropdown.classList.add('submenu-open')
      }, 300)
    }
    
    const mouseleaveHandler = () => {
      // Clear timeout and remove class
      if (dropdown._timeout) {
        clearTimeout(dropdown._timeout)
        dropdown._timeout = null
      }
      dropdown.classList.remove('submenu-open')
    }
    
    // Store handlers for cleanup
    dropdown._mouseenterHandler = mouseenterHandler
    dropdown._mouseleaveHandler = mouseleaveHandler
    
    // Add event listeners
    dropdown.addEventListener('mouseenter', mouseenterHandler)
    dropdown.addEventListener('mouseleave', mouseleaveHandler)
  })
}